import loadAmmoModule from './wasmLoader';
const PhysicsLoader = (path, callback) => {
    if (typeof window !== 'undefined')
        window.__loadPhysics = true;
    loadAmmoModule(path, () => {
        Ammo().then(() => {
            callback();
        });
    });
};
export { PhysicsLoader };
//# sourceMappingURL=physicsLoader.js.map